module.exports = __webpack_public_path__ + "static/media/giftEmailBanner.ae88fe69.png";